import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Icons from '../../../icons';

const CollapsableBlock = props => {
  const [isOpen, setIsOpen] = useState(props.isOpen || false);

  const toggleBlockOpen = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="profile-settings-container">
      <div className="profile-settings-block-header" onClick={toggleBlockOpen}>
        <p>{props.title}</p>
        <div>{!isOpen ? <Icons.CaretDown /> : <Icons.CaretUp />}</div>
      </div>
      {isOpen && <div className="profile-settings-block-content">{props.children}</div>}
    </div>
  );
};

CollapsableBlock.propTypes = {
  isOpen: PropTypes.bool,
  title: PropTypes.string.isRequired,
  children: PropTypes.element.isRequired,
};

export default CollapsableBlock;
